<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
  >
    <template v-slot:header="{ ok, cancel }">
      <v-card-title class="screen-title"
        >KDDI GPU Cloud向けVNコネクト情報</v-card-title
      >
      <button
        type="button"
        aria-label="Close"
        class="close"
        @click="isChanged ? ok() : cancel()"
      >
        ×
      </button>
    </template>
    <template v-if="isLoaded" v-slot:body="{ ok, cancel }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <v-sheet v-if="errorStatus">
              <v-sheet
                class="pa-4 text-body-2"
                :color="errorDetailColor"
                rounded
              >
                <v-row>
                  <v-icon
                    :icon="errorIcon"
                    size="30"
                    class="GpuServiceType mt-4"
                  />
                  <v-col>
                    <div
                      class="text-subtitle-1 font-weight-bold d-flex align-center pl-2"
                    >
                      エラーが発生しました。
                    </div>
                    <div
                      class="text-subtitle-1 font-weight-bold d-flex align-center pl-2"
                    >
                      ※以下の内容をご確認の上、<a
                        href="https://wvs2document.com/multi-cloud-errors-overview/"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Webマニュアル</a
                      >を参照してください。
                    </div>
                  </v-col>
                  <v-icon
                    :icon="expandedIcon"
                    size="30"
                    @click="isExpanded = !isExpanded"
                    class="d-flex cursor-pointer mt-4"
                  />
                </v-row>
              </v-sheet>
              <v-sheet
                v-if="isExpanded"
                class="pr-2 pl-2 text-body-2"
                color="gray"
                rounded
              >
                <v-col>
                  <div class="text-subtitle-1 font-weight-bold">
                    ステータス：{{ $filter.emptyTo(errorDetail?.id, "-") }}
                  </div>
                  <div class="text-subtitle-1 font-weight-bold reason-message">
                    理由：{{ $filter.emptyTo(errorDetail?.message, "-") }}
                  </div>
                  <div class="text-subtitle-1 font-weight-bold">
                    発生時刻：{{
                      $filter.datetime(errorDetail?.timestamp, { s: true }) ??
                      ""
                    }}
                  </div>
                </v-col>
              </v-sheet>
            </v-sheet>
            <v-row class="mt-2">
              <v-col class="d-flex flex-row ga-2 justify-end">
                <v-btn
                  v-if="errorMode.includes('R')"
                  v-permission.config
                  color="primary"
                  @click="VnConnectRetry(`R`)"
                  >再実行</v-btn
                >
                <v-btn
                  v-if="errorMode.includes('C')"
                  v-permission.config
                  color="primary"
                  @click="VnConnectRetry(`C`)"
                  >再作成</v-btn
                >
                <v-btn
                  v-if="errorMode.includes('M')"
                  v-permission.config
                  color="primary"
                  @click="showVNConnectModify"
                  >変更</v-btn
                >
                <v-btn
                  v-if="errorMode.includes('D')"
                  v-permission.config
                  color="primary"
                  @click="showVNConnectDelete"
                  >削除</v-btn
                >
              </v-col>
            </v-row>
            <v-row>
              <!-- クラウド設定 -->
              <v-col cols="6">
                <v-row>
                  <v-col>
                    <h3>基本設定</h3>
                  </v-col>
                </v-row>
                <div class="ml-2">
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="KDDI GPU Cloudご契約番号"
                        :value="cloudDetail.cloudVnConnectCommon.mNumber"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="回線番号"
                        :value="cloudDetail.enumber"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group label="品目">
                        <template #value>
                          <div class="ml-3">
                            {{
                              cloudDetail.cloudVnConnectCommon.bandwidthType
                            }}({{
                              $filter.bandwidthTo(
                                cloudDetail.cloudVnConnectCommon.bandwidth
                              )
                            }})
                          </div>
                        </template>
                      </app-label-group>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="ロケーション"
                        :value="
                          $filter.enumTo(
                            cloudDetail.cloudVnConnectCommon.location,
                            'location'
                          )
                        "
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="KBIテナントコード"
                        :value="cloudDetail.cloudVnConnectCommon.kbiTenantCode"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="備考"
                        :value="
                          $filter.emptyTo(
                            cloudDetail.cloudVnConnectCommon.description,
                            '-'
                          )
                        "
                      />
                    </v-col>
                  </v-row>
                </div>
              </v-col>

              <!--接続先VPN/VN -->
              <v-col cols="6">
                <v-row>
                  <v-col>
                    <h3>接続先VPN/VN</h3>
                  </v-col>
                </v-row>
                <div class="ml-2">
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="VPN/VNコード"
                        :value="cloudDetail.cloudVnConnectCommon.vpnVnCode"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="仮想ネットワーク(VN)名"
                        :value="
                          cloudDetail.cloudVnConnectCommon.vpnVnCode.startsWith(
                            'B'
                          )
                            ? '-'
                            : cloudDetail.cloudVnConnectCommon.vnName
                        "
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="L2/L3"
                        :value="cloudDetail.cloudVnConnectCommon.vnType"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="ルーティング種別"
                        :value="cloudDetail.cloudVnConnectCommon.routingType"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="AS番号"
                        :value="cloudDetail.cloudVnConnectCommon.asNumber"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="MD5キー"
                        :value="cloudDetail.cloudVnConnectCommon.md5Key"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="Maximum Prefix"
                        :value="cloudDetail.cloudVnConnectCommon.maximumPrefix"
                      />
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>

            <v-row class="mt-2">
              <!--回線情報（Act）-->
              <v-col cols="6">
                <v-row>
                  <v-col>
                    <h3>回線情報(Act)</h3>
                  </v-col>
                </v-row>
                <div class="ml-2">
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="VNコネクト番号"
                        :value="cloudDetail.cloudVnConnectAct.wnumber"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="VNコネクト名"
                        :value="cloudDetail.cloudVnConnectAct.vnConnectName"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="有効/無効"
                        :value="
                          $filter.enumTo(
                            cloudDetail.cloudVnConnectAct.isVnConnectStatus,
                            'enable'
                          )
                        "
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="IF状態"
                        :value="
                          $filter.enumTo(
                            cloudDetail.cloudVnConnectAct.ifStatus,
                            'cloudVn_ifStatus'
                          )
                        "
                      />
                    </v-col>
                  </v-row>
                </div>
              </v-col>

              <!-- 回線情報（Sby） -->
              <v-col cols="6">
                <v-row>
                  <v-col>
                    <h3>回線情報(Sby)</h3>
                  </v-col>
                </v-row>
                <div v-if="cloudDetail.cloudVnConnectSby" class="ml-2">
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="VNコネクト番号"
                        :value="cloudDetail.cloudVnConnectSby.wnumber"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="VNコネクト名"
                        :value="cloudDetail.cloudVnConnectSby.vnConnectName"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="有効/無効"
                        :value="
                          $filter.enumTo(
                            cloudDetail.cloudVnConnectSby.isVnConnectStatus,
                            'enable'
                          )
                        "
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="IF状態"
                        :value="
                          $filter.enumTo(
                            cloudDetail.cloudVnConnectSby.ifStatus,
                            'cloudVn_ifStatus'
                          )
                        "
                      />
                    </v-col>
                  </v-row>
                </div>
                <div v-else class="ml-3">-</div>
              </v-col>
            </v-row>

            <v-row class="mt-2">
              <!-- ルーティング情報（Act） -->
              <v-col cols="6">
                <v-row>
                  <v-col>
                    <h3>ルーティング情報(Act)</h3>
                  </v-col>
                </v-row>
                <div class="ml-2">
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="WANアドレス"
                        :value="cloudDetail.cloudVnConnectAct.wanAddress"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="ピアIPアドレス"
                        :value="cloudDetail.cloudVnConnectAct.peerIpAddress"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="Local Preference"
                        :value="
                          $filter.enumTo(
                            cloudDetail.cloudVnConnectAct.localPreference,
                            'localPreference'
                          )
                        "
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="MED"
                        :value="
                          $filter.enumTo(
                            cloudDetail.cloudVnConnectAct.med,
                            'med'
                          )
                        "
                      />
                    </v-col>
                  </v-row>
                </div>
              </v-col>

              <!-- ルーティング情報（Sby） -->
              <v-col cols="6">
                <v-row>
                  <v-col>
                    <h3>ルーティング情報(Sby)</h3>
                  </v-col>
                </v-row>
                <div v-if="cloudDetail.cloudVnConnectSby" class="ml-2">
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="WANアドレス"
                        :value="cloudDetail.cloudVnConnectSby.wanAddress"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="ピアIPアドレス"
                        :value="cloudDetail.cloudVnConnectSby.peerIpAddress"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="Local Preference"
                        :value="
                          $filter.enumTo(
                            cloudDetail.cloudVnConnectSby.localPreference,
                            'localPreference'
                          )
                        "
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="MED"
                        :value="
                          $filter.enumTo(
                            cloudDetail.cloudVnConnectSby.med,
                            'med'
                          )
                        "
                      />
                    </v-col>
                  </v-row>
                </div>
                <div v-else class="ml-3">-</div>
              </v-col>
            </v-row>

            <v-row class="mt-2">
              <!-- カスタム経路集約情報 -->
              <v-col cols="12">
                <v-row>
                  <v-col>
                    <h3>カスタム経路集約情報</h3>
                  </v-col>
                </v-row>
                <div class="ml-2">
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="経路集約"
                        :value="
                          cloudDetail.cloudVnConnectCommon.routeAggregation
                        "
                      />
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="
                      cloudDetail.cloudVnConnectCommon.routeAggregation !==
                      'OFF'
                    "
                  >
                    <v-col>
                      <app-label-group label="経路集約アドレス">
                        <template #value>
                          <template
                            v-if="
                              cloudDetail.cloudVnConnectCommon
                                .routeAggregation === 'CUSTOM'
                            "
                          >
                            <div class="d-flex flex-wrap">
                              <span
                                class="ml-3"
                                v-for="(
                                  ip, index
                                ) in sortedRouteAggregationAddressList"
                                :key="index"
                              >
                                {{ ip }}
                              </span>
                            </div>
                          </template>
                          <template
                            v-else-if="
                              cloudDetail.cloudVnConnectCommon
                                .routeAggregation === 'ON'
                            "
                          >
                            <span class="ml-3">0.0.0.0/0</span>
                          </template>
                        </template>
                      </app-label-group>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>

            <v-row class="mt-6" v-if="isShowOperationTabs">
              <v-col>
                <v-tabs
                  v-model="tabValue"
                  @update:modelValue="alertClear"
                  hide-slider
                  class="border-s-sm border-t-sm border-e-sm"
                >
                  <!--運用コマンド(Act)-->
                  <v-tab text="運用コマンド(Act)" value="operationCommandAct" />
                  <!--運用コマンド(Sby)-->
                  <v-tab
                    v-if="cloudDetail.cloudVnConnectSby"
                    text="運用コマンド(Sby)"
                    value="operationCommandSby"
                  />
                  <!--トラフィック-->
                  <v-tab
                    text="トラフィック"
                    value="traffic"
                    v-if="!isFutureDayContract && contractSummary.isTrafficInfo"
                  />
                  <v-tab text="設定上限値" value="upperLimit" />
                </v-tabs>
                <v-tabs-window
                  v-model="tabValue"
                  class="border-s-sm border-b-sm border-e-sm"
                >
                  <!--運用コマンド(Act)-->
                  <v-tabs-window-item value="operationCommandAct">
                    <operation-command
                      ref="operationCommandAct"
                      lineCategory="CLOUD"
                      :wnumber="cloudDetail.cloudVnConnectAct.wnumber"
                      :ifStatus="cloudDetail.cloudVnConnectAct.ifStatus"
                      :key-id="cloudDetail.cloudVnGpuKeyId"
                      @executed="executed"
                    ></operation-command>
                  </v-tabs-window-item>

                  <!--運用コマンド(Sby)-->
                  <v-tabs-window-item value="operationCommandSby">
                    <operation-command
                      ref="operationCommandSby"
                      lineCategory="CLOUD"
                      :wnumber="cloudDetail.cloudVnConnectSby!.wnumber"
                      :ifStatus="cloudDetail.cloudVnConnectSby!.ifStatus"
                      :key-id="cloudDetail.cloudVnGpuKeyId"
                      @executed="executed"
                    ></operation-command>
                  </v-tabs-window-item>

                  <!--トラフィック-->
                  <v-tabs-window-item value="traffic">
                    <traffic
                      line-type="MULTICLOUD"
                      :line="{
                        wnumberMainAct: cloudDetail.cloudVnConnectAct.wnumber,
                        wnumberMainSby: cloudDetail.cloudVnConnectSby
                          ? cloudDetail.cloudVnConnectSby.wnumber
                          : undefined,
                      }"
                    />
                  </v-tabs-window-item>

                  <!--設定上限値-->
                  <v-tabs-window-item value="upperLimit">
                    <upper-limit
                      upperLimitManageUnit="MULTI_CLOUD"
                      :wnumber="cloudDetail.cloudVnConnectAct.wnumber"
                      :cloud-line-seq="cloudLineSeq"
                    />
                  </v-tabs-window-item>
                </v-tabs-window>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn
              @click="isChanged ? ok() : cancel()"
              variant="outlined"
              color="primary"
              >戻る</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import { VueFinalModal } from "vue-final-modal";
import type { CloudVnGpuDetail } from "@/apis/CloudVnGpuApi";
import MultiCloudGpuVnConnectionDeleteConfirm from "@/modals/multicloud/gpu/MultiCloudGpuVnConnectionDeleteConfirm.vue";
import { mapState } from "vuex";
import type { ContractInfo } from "@/apis/ContractApi";
import Traffic from "@/components/operation-tool/Traffic.vue";
import OperationCommand from "@/components/operation-tool/OperationCommand.vue";
import UpperLimit from "@/components/operation-tool/UpperLimit.vue";
import MultiCloudGpuVnLineEdit from "@/modals/multicloud/gpu/MultiCloudGpuVnLineEdit.vue";
import { ApiForbiddenError } from "@/error/errors";
import { parseErrorDetail } from "@/services/ErrorDetailParser";

export default defineComponent({
  name: "MultiCloudGpuVnConnectionReference",
  components: { OperationCommand, Traffic, UpperLimit },
  props: {
    wnumber: {
      type: String as PropType<string>,
      required: true,
    },
    cloudLineSeq: {
      type: String as PropType<string>,
      required: true,
    },
    remainingBandwidth: {
      type: Number as PropType<number>,
      required: true,
    },
  },
  data() {
    return {
      cloudDetail: {} as CloudVnGpuDetail,
      isLoaded: false,
      isChanged: false,
      tabValue: "operationCommandAct" as
        | "operationCommandSby"
        | "traffic"
        | "upperLimit",
      isExpanded: true,
      isShowOperationTabs: true,
    };
  },
  async mounted() {
    await this.load();
    this.isLoaded = true;
  },
  computed: {
    ...mapState("user", {
      contractInfo: "contractInfo",
      contractSummary: "contractSummary",
    }),
    /** 開始日が未来日の場合,true*/
    isFutureDayContract(): boolean {
      return !this.contractInfo.contractList.find(
        (e: ContractInfo["contractList"][0]) =>
          e.enumber === this.cloudDetail.enumber
      );
    },
    /** 経路集約アドレス（数値昇順ソート済み） */
    sortedRouteAggregationAddressList(): string[] {
      const list =
        this.cloudDetail.cloudVnConnectCommon?.routeAggregationAddressList ??
        [];
      return list.sortIpAddress();
    },
    /** エラーステータス */
    errorStatus(): boolean {
      const status = this.cloudDetail.cloudVnConnectCommon.provStatus;
      return (
        status === "RETRYABLE" ||
        status === "CREATE_FAILED" ||
        status === "FAILED" ||
        status === "PENDING_DELETE" ||
        status === "DELETE_RETRYABLE"
      );
    },
    /** エラー時のアイコンを選択 */
    errorIcon(): string {
      const status = this.cloudDetail.cloudVnConnectCommon.provStatus;
      if (status === "RETRYABLE" || status === "DELETE_RETRYABLE") {
        return "$mdiCloseCircle";
      } else if (
        status === "FAILED" ||
        status === "PENDING_DELETE" ||
        status === "CREATE_FAILED"
      ) {
        return "$mdiAlertCircle";
      }
      return "";
    },
    /** 展開アイコン */
    expandedIcon(): string {
      return this.isExpanded ? "$mdiChevronUp" : "$mdiChevronDown";
    },
    /** エラー詳細のカラーを選択 */
    errorDetailColor(): string {
      const status = this.cloudDetail.cloudVnConnectCommon.provStatus;
      if (
        status === "RETRYABLE" ||
        status === "DELETE_RETRYABLE" ||
        status === "CREATE_FAILED" ||
        status === "PENDING_DELETE"
      ) {
        return "error";
      } else if (status === "FAILED") {
        return "warning";
      }
      return "";
    },
    /**  エラー状態によるボタン表示関係
     *  R：再実行可能状態
     *  D：削除可能状態
     *  M：変更可能状態
     * 上記状態の組み合わせで制御
     */
    errorMode(): string {
      const status = this.cloudDetail.cloudVnConnectCommon.provStatus;
      if (status === "RETRYABLE") {
        return "RD";
      } else if (status === "PENDING_DELETE") {
        return "D";
      } else if (status === "DELETE_RETRYABLE") {
        return "R";
      } else if (status === "CREATE_FAILED") {
        return "RD";
      }
      return "MD";
    },
    /** errorDetail JSONから表示用ステータス詳細を抽出 */
    errorDetail(): {
      id: string | null;
      message: string | null;
      timestamp: string | null;
    } | null {
      return parseErrorDetail(
        this.cloudDetail.cloudVnConnectCommon.errorDetail,
        "GPU Server Error"
      );
    },
  },
  methods: {
    async load() {
      // cloudDetailは必ず取得
      this.cloudDetail = await this.$api.cloudVnGpu.getVnConnect(this.wnumber);
      // 403チェックの前にリセットする（再ロード時に前回のfalseを引き継がないようにするため）
      this.isShowOperationTabs = true;
      try {
        // クラコン側にデータが無い場合に運用コマンドAPIが403を返すため、事前に403判定する目的で呼び出す
        // 正常時はOperationCommand内で再度同APIが呼ばれるが、403回避のためやむを得ない
        await this.$api.nwOperationTool.getCommandResultsVN(
          "CLOUD",
          this.wnumber
        );
      } catch (error) {
        // 403の場合は運用コマンドタブを非表示にする（表示したままだとエラーになるため）
        if (error instanceof ApiForbiddenError) {
          this.isShowOperationTabs = false;
        } else {
          // 403以外は共通エラーハンドラで処理
          throw error;
        }
      }
    },
    /** 削除 */
    async showVNConnectDelete() {
      await this.alertClear();
      // 削除確認モーダルの表示
      await this.$modal.show(MultiCloudGpuVnConnectionDeleteConfirm, {
        cloudVnGpuDetail: this.cloudDetail,
      });
      // 削除処理
      await this.$api.cloudVnGpu.deleteVnConnect(this.cloudLineSeq, {
        cloudVnConnectList: this.cloudDetail.cloudVnConnectSby?.wnumber
          ? [
              this.cloudDetail.cloudVnConnectAct.wnumber,
              this.cloudDetail.cloudVnConnectSby.wnumber,
            ]
          : [this.cloudDetail.cloudVnConnectAct.wnumber],
        cloudVnGpuKeyId: this.cloudDetail.cloudVnGpuKeyId,
      });
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },

    /** 変更 */
    async showVNConnectModify() {
      await this.alertClear();
      // 変更モーダルの表示
      await this.$modal.show(MultiCloudGpuVnLineEdit, {
        cloudLineSeq: this.cloudLineSeq,
        cloudVnGpuDetail: this.cloudDetail,
        remainingBandwidth: this.remainingBandwidth,
      });
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },

    /** 再実行 */
    async VnConnectRetry(displayType: "R" | "C") {
      await this.alertClear();
      if (displayType === "R") {
        await this.$confirm(`VNコネクト再実行を行います。よろしいですか？`);
      } else if (displayType === "C") {
        await this.$confirm(`VNコネクト再作成を行います。よろしいですか？`);
      }
      await this.$api.cloudVnGpu.cloudVnGpuRetry(
        this.cloudLineSeq,
        this.cloudDetail.cloudVnConnectAct.wnumber,
        {
          cloudVnGpuKeyId: this.cloudDetail.cloudVnGpuKeyId,
        }
      );
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },

    /**
     * コマンド実行後の処理
     * IF設定反映の場合、一覧画面へ戻る
     * @param eventType 実行されたコマンドの種類
     */
    async executed(eventType: string) {
      if (eventType === "IF_STATE") {
        (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
      } else {
        this.isChanged = true;
        await this.load();
      }
    },
    /** エラーメッセージを初期化する */
    async alertClear() {
      if (
        this.cloudDetail.cloudVnConnectAct &&
        this.$refs.operationCommandAct
      ) {
        (
          this.$refs.operationCommandAct as
            | InstanceType<typeof OperationCommand>
            | undefined
        )?.alertClear();
      }
      if (
        this.cloudDetail.cloudVnConnectSby &&
        this.$refs.operationCommandSby
      ) {
        (
          this.$refs.operationCommandSby as
            | InstanceType<typeof OperationCommand>
            | undefined
        )?.alertClear();
      }
    },
  },
});
</script>

<style lang="scss" scoped>
.reason-message {
  max-height: 330px;
  overflow-y: auto;
}
</style>
